/** Datensaetze der Synchronisierung (T-04) - lokal, nie in der Sicherung. */
import type { KonfliktArt, Uhren } from '@/domain/sync/zusammenfuehren';
import type { Uhr } from '@/domain/sync/uhr';

/** Feld-Uhren eines Eintrags und der Serverstand, auf dem sie beruhen. */
export interface SyncFeldStand {
  /** `tabelle/id` */
  schluessel: string;
  tabelle: string;
  id: string;
  f: Uhren;
  x?: Uhr;
  /** Uhren des Serverstands beim letzten Abgleich (Basis fuer Konflikte). */
  bf: Uhren;
  bx?: Uhr;
  /** Laufnummer dieses Serverstands, 0 = noch nie hochgeladen. */
  seq: number;
  /** 1 = lokal geaendert, muss hochgeladen werden. */
  offen: 0 | 1;
  /** Nur Anhaenge: Datei liegt schon in R2. */
  datei?: 1;
}

export interface SyncKonflikt {
  id: string;
  zeit: string;
  tabelle: string;
  eintragId: string;
  /** Zur Anzeige: Titel oder Name des Eintrags. */
  titel: string;
  art: KonfliktArt;
  feld?: string;
  verloren?: unknown;
  gewonnen?: unknown;
}

export const syncSchluessel = (tabelle: string, id: string) => `${tabelle}/${id}`;

/** Was ein Eintrag als Ueberschrift hergibt - fuer Konfliktmeldungen. */
export function eintragTitel(d: Record<string, unknown> | null | undefined): string {
  if (!d) return '';
  for (const k of ['title', 'name', 'titel', 'frage', 'text', 'date', 'datum', 'isoWeek']) {
    const v = d[k];
    if (typeof v === 'string' && v.trim()) return v.trim().slice(0, 80);
  }
  return '';
}
